// extracted by mini-css-extract-plugin
module.exports = {"guestTag":"member-operations__TimelineCard__guestTag"};